module.exports = __webpack_public_path__ + "static/01-680f65db72b42005d2d2a8599e75a1aa.jpg";